import React from "react";
import { ShieldAlert } from "lucide-react";

export function Disclaimer({ children, testId = "compliance-disclaimer-banner", className = "" }) {
  return (
    <div className={`disclaimer-banner flex gap-3 items-start ${className}`} data-testid={testId}>
      <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0" />
      <p>
        {children ||
          "Look Before You Leap 808 is an informational workspace only. It does not rate neighborhoods, schools, or safety, and does not provide legal, financial, or tax advice. Always confirm important decisions with your agent and a licensed professional. Final decisions are yours."}
      </p>
    </div>
  );
}
